import React, {
  createContext,
  type Dispatch,
  type SetStateAction,
  useState,
} from 'react';

export interface MobileHeaderContextValue {
  stickyNavVisible: boolean;
  toggleStickyNavVisibility: Dispatch<SetStateAction<boolean>>;
  menuOpen: boolean;
  setMenuOpen: Dispatch<SetStateAction<boolean>>;
  searchOpen: boolean;
  setSearchOpen: Dispatch<SetStateAction<boolean>>;
  roomTypesOpen: boolean;
  setRoomTypesOpen: Dispatch<SetStateAction<boolean>>;
}

export const MobileHeaderContext = createContext<MobileHeaderContextValue>({
  stickyNavVisible: false,
  toggleStickyNavVisibility: () => {},
  menuOpen: false,
  setMenuOpen: () => {},
  searchOpen: false,
  setSearchOpen: () => {},
  roomTypesOpen: false,
  setRoomTypesOpen: () => {},
});

const MobileHeaderProvider = ({ children }: { children?: React.ReactNode }) => {
  const [stickyNavVisible, toggleStickyNavVisibility] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [roomTypesOpen, setRoomTypesOpen] = useState(false);

  return (
    <MobileHeaderContext.Provider
      value={{
        stickyNavVisible,
        toggleStickyNavVisibility,
        menuOpen,
        setMenuOpen,
        searchOpen,
        setSearchOpen,
        roomTypesOpen,
        setRoomTypesOpen,
      }}
    >
      {children}
    </MobileHeaderContext.Provider>
  );
};

export default MobileHeaderProvider;
